import { getSvocId, getUserId } from './user';
/**
 * Creates a composite user ID for personalized deals.
 * @param {boolean} isB2bOnly - Whether to only return IDs for B2B customers
 * @param {string} [customerType] - Optional customer type string (e.g., 'B2B', 'B2C')
 * @returns {string | undefined} The combined 'svocId_userId' string, or undefined if either ID is missing.
 */
export var getPersonalizedDealsUserId = function (isB2bOnly, customerType) {
    if (isB2bOnly === void 0) { isB2bOnly = false; }
    // SSR safety check
    if (typeof window === 'undefined')
        return undefined;
    var svocId = getSvocId();
    var userId = getUserId();
    // Check if customer is B2B based on provided customerType
    var isB2b = (customerType === null || customerType === void 0 ? void 0 : customerType.toUpperCase()) === 'B2B';
    // If B2B only mode and not B2B, return undefined
    if (isB2bOnly && !isB2b)
        return undefined;
    if (svocId && userId) {
        return "".concat(svocId, "_").concat(userId);
    }
    return undefined;
};
